import React from 'react'

export default function Legal() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
   <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
            <div className="sm:text-center ">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
                <span className="block xl:inline">Condiciones y Privacidad</span>{' '}
                <span className="block text-cyan-600 xl:inline">Budgie Cuba</span>
              </h1>


              <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-10">
                <span className="block xl:inline">DECLARACONES:</span>
               
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              1. Declara ser una sociedad anónima de capital variable.
              </p>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              2. Su objeto social es el de la prestación de servicios informáticos basado en la ubicación del usuario.
              </p>

              <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-10">
                <span className="block xl:inline">ASÍ LO DECLARAN:</span>               
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              1. Los datos que aparecen que aparecen de esta guía son los correctos.
              </p>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              2. Somos responsables del contenido de lo que brindamos.
              </p>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              3. Se acepta que al hacerse uso de los servicios de la compañía Budgie, reconoce y admite expresamente los
               términos y condiciones aquí contenidos y los que aparecerán en la guía Internacional.
              </p>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              4. Se declaran ambas partes que para los efectos del presente contrato aceptan y reconocen las siguientes condiciones:
              </p>


              <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-10">
                <span className="block xl:inline">¿Cómo usa Budgie mis datos?</span>               
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              Algunas características y funcionalidades de nuestras App exigen que nos proporcione su ubicación. Si tiene los servicios de ubicación activados, cada vez que use nuestras App en su dispositivo móvil, nosotros recopilamos y usamos sus coordenadas geográficas (p. ej., latitud y longitud) para adaptar los Servicios al consumidor a su ubicación actual. Solo procesaremos su ubicación con su permiso expreso. Si tiene activada la ubicación en segundo plano persistente, obtendremos la ubicación de su dispositivo incluso cuando no esté usando las Apps. Jamás compartiremos su ubicación
            con otros, excepto con su consentimiento o conforme lo permita esta Política de privacidad.
              </p>

              <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-10">
                <span className="block xl:inline">Niños menores de 13 años</span>               
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              Nuestros Servicios al consumidor están destinados a un público general y no a niños. No recopilamos intencionalmente información personal en línea
             de personas menores de 13 años ni de cualquier otra edad, conforme pueda exigirlo la ley aplicable.
              </p>

              <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-10">
                <span className="block xl:inline"> Contáctese con nosotros</span>               
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
              Si tiene alguna pregunta o inquietud con respecto a esta Política de privacidad, envíe un mensaje detallado a nuestro Responsable de Protección de Datos a: privacidad@budgiecuba.com 
              o a Budgie FL,  20054 nw 65 ct Hialeah FL de ci 781224. Haremos todo lo que esté a nuestro alcance para resolver sus inquietudes.
              </p>
             
          
            </div>
          </main>
  
    </div>
  )
}
